<script setup lang="ts">
</script>
<template>
  <div>
    <Toaster richColors />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
